export default __webpack_public_path__ + "static/media/Run.85ffcb6e.png";